import { Box, Divider, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { BsPlusCircleDotted } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import * as Yup from 'yup'
import Employee from '../../../../../../api/db/Employee'
import { selectCurrrentAdminShop } from '../../../../../../store/features/currentBusinessShop'
import { selectUserPropsState } from '../../../../../../store/features/user'
import ValidatedButton from '../../../../../organisms/validation/admin/ValidatedButton.admin'
import ValidatedCheckGroup from '../../../../../organisms/validation/admin/ValidatedCheckGroup.admin'
import ValidatedForm from '../../../../../organisms/validation/admin/ValidatedForm.admin'
import ValidatedInputStringGenerator from '../../../../../organisms/validation/admin/ValidatedInputStringGenerator.admin'
import ValidatedTextInput from '../../../../../organisms/validation/admin/ValidatedTextInput.admin'
import { IAddFormProps } from '../../../../../../shared/types'


const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    roles: [],
}

const validationSchema = Yup.object().shape({
    first_name: Yup.string().required().min(2).label("First name"),
    last_name: Yup.string().required().min(2).label("Last name"),
    email: Yup.string().email().required().label("Email"),
    password: Yup.string().required().label("Password"),
    roles: Yup.array(Yup.string()).min(1)
})

export default function AddNewEmployee({onDone, onFail}:IAddFormProps) {

    const [isLoading, setIsLoading] = useState(false)
    const user_id = useSelector(selectUserPropsState)?.uid
    const current_shop = useSelector(selectCurrrentAdminShop)?.name

    const handleSubmit = async(values: typeof initialValues)=>{

        try {

            setIsLoading(true)
    
            const employee_data = {
                ...values, 
                account_type: "shopkeeper",
                business_id: user_id,
                branch: current_shop,
                uid: "",
                revenue: 0,
                created_at: new Date()
            }

            await Employee.addEmployee(employee_data)
            setIsLoading(false)
            onDone()
            
        } catch (error) {
            setIsLoading(false)
            onFail(error)
            throw error
        }

    }
    
  return (
        <ValidatedForm
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            <Box>

                <Box
                    sx={{width: "100%", height: "20rem", overflow: "auto"}}
                >
                    <Stack 
                        direction="row"
                        sx={{width: "100%", marginBottom: "1rem"}}
                        spacing={2}
                    >
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="grey.500">First name</Typography>
                            <ValidatedTextInput name="first_name" type="text" />
                        </Stack>
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="grey.500">Last name</Typography>
                            <ValidatedTextInput name="last_name" type="text" />
                        </Stack>
                    </Stack>
                    <Divider sx={{marginTop: "0.5rem", marginBottom: "0.5rem"}} />
                    <Stack 
                        direction="row"
                        sx={{width: "100%", marginBottom: "1rem"}}
                        spacing={2}
                    >
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="grey.500">Email</Typography>
                            <ValidatedTextInput name="email" type="text" />
                        </Stack>
                    </Stack>
                    <Divider sx={{marginTop: "0.5rem", marginBottom: "0.5rem"}} />
                    <Stack 
                        direction="row"
                        sx={{width: "100%", marginBottom: "1rem"}}
                        spacing={2}
                    >
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="grey.500">Password</Typography>
                            <ValidatedInputStringGenerator name="password" />
                        </Stack>
                    </Stack>
                    <Divider sx={{marginTop: "0.5rem", marginBottom: "0.5rem"}} />
                    <Stack 
                        direction="row"
                        sx={{width: "100%", marginBottom: "1rem"}}
                        spacing={2}
                    >
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="grey.500">Roles</Typography>
                            <ValidatedCheckGroup name="roles" labels={[
                                "sales",
                                "inventory management"
                            ]} />
                        </Stack>
                    </Stack>
                    
                </Box>

                <Box
                    sx={{marginTop: "1.5rem", display: "flex", justifyContent: "flex-end"}}
                >
                    
                    <ValidatedButton 
                        startIcon={<BsPlusCircleDotted />} 
                        variant="contained" 
                        color="secondary" 
                        disableElevation={true}
                        loading={isLoading}
                    >
                        <Typography  color="primary" sx={{fontSize: "13px"}}>Add</Typography>
                    </ValidatedButton>
                </Box>
                
            </Box>

        </ValidatedForm>
  )
}
